import { configureStore, createSlice } from '@reduxjs/toolkit';

// Placeholder slice to prevent empty reducer error
const appSlice = createSlice({
  name: 'app',
  initialState: {},
  reducers: {},
});

// Create the Redux store
export const store = configureStore({
  reducer: {
    app: appSlice.reducer,
    // Add your other reducers here when needed
    // Example: auth: authReducer,
  },
  // Add middleware here if needed
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializable check for non-serializable values like functions
    }),
});

export default store;
